import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "aeptext"
    }}>{`AEPText`}</h1>
    <p>{`The AEPText class is a fundamental UI component used to display text for content cards.`}</p>
    <p>{`This class allows you to customize the text element with properties like font, color, and modifier.`}</p>
    <p>{`AEPText class conforms to `}<inlineCode parentName="p">{`ObservableObject`}</inlineCode>{`, allowing it to be used reactively in SwiftUI views.`}</p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`content`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The actual text content to be displayed.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`font`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://developer.apple.com/documentation/swiftui/font"
            }}>{`Font`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The font to be used for the text.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Depends on the type of text:  `}<ul><li><strong parentName="td">{`Title`}</strong>{`:  `}<br />{`  System font `}<br />{` Size 15 `}<br />{` Medium weight`}</li><li><strong parentName="td">{`Body`}</strong>{` : `}<br />{` System font `}<br />{` Size 13 `}<br />{` Regular weight `}<br /></li><li><strong parentName="td">{`ButtonText`}</strong>{` :  `}<br />{` System font  `}<br />{` Size 13  `}<br />{` Regular weight`}</li></ul></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://developer.apple.com/documentation/swiftui/color"
            }}>{`Color`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The color of the text.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Depends on the type of text:    `}<ul><li><strong parentName="td">{`Title`}</strong>{`: `}<a parentName="td" {...{
                  "href": "https://developer.apple.com/documentation/swiftui/color/primary"
                }}>{`primary`}</a></li>{`   `}<li><strong parentName="td">{`Body`}</strong>{`: `}<a parentName="td" {...{
                  "href": "https://developer.apple.com/documentation/swiftui/color/primary"
                }}>{`secondary`}</a></li><li>{`    `}<strong parentName="td">{`ButtonText`}</strong>{`: `}<a parentName="td" {...{
                  "href": "https://developer.apple.com/documentation/swiftui/color/blue"
                }}>{`blue`}</a>{` `}</li></ul></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`modifier`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`AEPViewModifier`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A custom view modifer that can be applied to the text view for additional styling`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
        </tr>
      </tbody>
    </table>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`All properties are marked with `}<a parentName="p" {...{
        "href": "https://developer.apple.com/documentation/combine/published"
      }}>{`@Published`}</a>{`. Any changes will trigger updates to your UI.`}</p>
    <h2 {...{
      "id": "customization"
    }}>{`Customization`}</h2>
    <p>{`Below is an example of how to customize the `}<inlineCode parentName="p">{`AEPText`}</inlineCode>{` properties when working with a `}<inlineCode parentName="p">{`SmallImageTemplate`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`class MyCustomizer : ContentCardCustomizing {
    
    func customize(template: SmallImageTemplate) {        
        // Customize the title text element
        template.title.font = .subheadline
        template.title.textColor = .green        
        template.title.modifier = AEPViewModifier(MyTitleModifier())
        
        // Customize the body text element, if available
        template.body?.font = .caption        
    }
    
    struct MyTitleModifier: ViewModifier {
        func body(content: Content) -> some View {
            content
                .padding()
                .background(Color.yellow)
                .cornerRadius(5)
        }
    }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      